let isEnabled: any;
export function checkIfFranceHalfSeasonEnabled() {
    if (typeof isEnabled !== 'undefined') {
        return isEnabled;
    }

    try {
        const isFeatureEnabled =
            window.dazn.features.isEnabledAnonymous('f_ar_half_season');
        isEnabled = isFeatureEnabled;
        return isFeatureEnabled;
    } catch (e) {
        return false;
    }
}
